import { english } from './english';
import { french } from './french';

export const resources = {
    en: english,
    fr: french
};
